<template>
  <div>
    <transition
      v-if="showModal"
      name="custom-classes-transition"
      enter-active-class="animated bounceInLeft"
      leave-active-class="animated bounceOutRight"
    >
      <div class="detail-modal">
        <div
          class="close-show-detail"
          @click="closeModal"
          style="position: absolute; right: 10px; z-index: 10000"
        >
          <eva-icon
            name="close-circle"
            fill="#FFF"
            width="50"
            height="50"
          ></eva-icon>
        </div>
        <div class="progress-job-list-box">
          <template
            v-if="
              showRecord && UserId !== '00000000-0000-0000-0000-000000000000'
            "
          >
            <perfect-scrollbar class="progress-job-list">
              <div
                v-for="record in recordList"
                :key="record.index"
                class="job-item"
                :class="{
                  active: record.MatchId === jobRecordMatchId,
                }"
                @click="clickRecord(record.MatchId)"
              >
                <div class="time">
                  <div class="status">{{ record.InterviewResult }}</div>
                </div>
                <div class="info">
                  <div class="job-name">{{ record.ManpowerDemandName }}</div>
                  <div class="d-number">{{ record.ManpowerDemandNo }}</div>
                </div>
              </div>
            </perfect-scrollbar>

            <perfect-scrollbar v-if="showProgress" class="timeline">
              <ul>
                <li class="welcome">
                  <div>{{ Name }}</div>
                  <span>求職歷程</span>
                </li>
                <li v-for="history in jobHistoryList" :key="history.index">
                  <div>
                    <div class="icon-wrap">
                      <eva-icon fill="#FFF" name="pricetags-outline"></eva-icon>
                    </div>
                    <template v-if="history.TypeName === 'WriteResume'">
                      <div class="time-wrap">
                        <h4>
                          <strong>應聘者履歷</strong>
                        </h4>
                      </div>
                    </template>
                    <template v-else>
                      <div class="time-wrap">
                        {{ history.OccurDate }}
                      </div>
                      <div class="text-wrap">{{ history.Status }}</div>
                      <div class="button-wrap">
                        <template v-if="history.Status === '面談結果-複試'">
                          <button
                            type="button"
                            class="btn"
                            @click="viewInterview(history.InterviewId)"
                          >
                            檢視面談紀錄
                          </button>
                          <button
                            type="button"
                            class="btn"
                            style="margin-left: 10px;"
                            @click="openInterviewProgress(MatchId)"
                          >
                            檢視面談紀錄歷程
                          </button>
                        </template>
                      </div>
                    </template>
                    <div class="button-wrap">
                      <button
                        v-if="history.TypeName === 'WriteResume'"
                        type="button"
                        class="btn"
                        @click="viewResume"
                      >
                        檢視履歷
                      </button>
                      <button
                        v-if="history.TypeName === 'InterviewInvitation'"
                        type="button"
                        class="btn"
                        data-toggle="modal"
                        @click="openInterviewMail(history.InterviewId)"
                      >
                        檢視邀約信件
                      </button>
                      <template v-if="history.TypeName === 'ThanksNotice'">
                        <button
                          type="button"
                          class="btn"
                          data-toggle="modal"
                          @click="openThanksMail"
                        >
                          檢視感謝函
                        </button>
                      </template>
                      <button
                        v-if="history.TypeName === 'HireNotice'"
                        type="button"
                        class="btn"
                        data-toggle="modal"
                        @click="openHiredMail"
                      >
                        檢視錄取信件
                      </button>
                      <button
                        v-if="history.TypeName === 'ReportNotice'"
                        type="button"
                        class="btn"
                        data-toggle="modal"
                        @click="openReportedMail"
                      >
                        檢視報到信件
                      </button>
                    </div>
                  </div>
                </li>
              </ul>
            </perfect-scrollbar>
          </template>
          <template
            v-if="
              !showRecord || UserId === '00000000-0000-0000-0000-000000000000'
            "
          >
            <section>
              <div class="notice">
                <img src="@/assets/img/no_record.png" alt="" />
                <p>{{ Name }}尚未應徵任何職缺</p>
              </div>
            </section>
          </template>
        </div>
      </div>
    </transition>

    <!-- 信件 Modal -->
    <div
      id="mailModal"
      class="modal fade bd-example-modal-xl"
      tabindex="-1"
    >
      <div
        class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg"
      >
        <div class="modal-content">
          <perfect-scrollbar class="modal-body">
            <div class="title">
              <h2>
                <i class="fa fa-briefcase icon1" aria-hidden="true"></i>
                <span class="sr-only">Interview Invitation Letter</span>
              </h2>
              <h4>{{ mailContent.Subject }}</h4>
            </div>
            <div class="form-content">
              <p v-html="mailContent.Body"></p>
            </div>
          </perfect-scrollbar>
        </div>
      </div>
    </div>

    <!-- 面談紀錄 Modal -->
    <div
      class="modal fade"
      id="historyModal"
      tabindex="-1"
      data-backdrop="static"
    >
      <div
        class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
      >
        <div class="modal-content">
          <div class="modal-header">
            <span>面談紀錄歷程</span>
          </div>
          <div class="modal-body">
            <div class="evaluation-person-info">
              <div>
                <label for="">姓名</label>
                <div>{{ interviewList.Interviewee }}</div>
              </div>

              <div>
                <label for="">面談日期</label>
                <div>
                  {{ $common.dateFormatter(interviewList.InterviewDate) }}
                </div>
              </div>

              <div v-for="score in interviewList.Scores" :key="score.Seq">
                <label for="">{{ score.Name }}</label>
                <div>{{ score.OriginScore }}/{{ score.Score }}</div>
              </div>
            </div>
            <template
              v-if="
                interviewList.InterviewRecords &&
                interviewList.InterviewRecords.length > 0
              "
            >
              <div style="display: flex; margin-top: 2px">
                <div class="evaluation-body fixed">
                  <div class="evaluation-name">單位面試主管</div>
                  <div
                    v-for="item in interviewList.InterviewRecords[0]
                      .InterviewRecordAppraisals"
                    :key="item.Name"
                    class="evaluation-field"
                  >
                    {{ item.Name }}
                  </div>

                  <template v-if="interviewList.ResumeType === 'IDL'">
                    <div class="evaluation-field">職等</div>
                  </template>

                  <div
                    class="evaluation-field"
                    style="height: 150px; overflow-y: auto"
                  >
                    面談說明
                  </div>

                  <div
                    class="evaluation-field"
                    style="height: 150px; overflow-y: auto"
                  >
                    個人備註
                  </div>
                  <div
                    class="evaluation-field"
                    style="
                      border-bottom: 0.1px solid;
                      border-bottom-color: #dfdfdf;
                    "
                  >
                    面談結果
                  </div>
                </div>

                <div style="flex: 1; min-width: 1px">
                  <carousel
                    :key="Math.random()"
                    :items="interviewList.InterviewRecords.length"
                    :nav="true"
                    :dots="false"
                  >
                    <div
                      v-for="record in interviewList.InterviewRecords"
                      class="evaluation-body"
                      :key="record.InterviewSupervisorId"
                      @dblclick="$common.copyText($event)"
                    >
                      <div class="evaluation-name">
                        {{ record.InterviewSupervisor }} ({{
                          record.InterviewUserType
                        }})
                      </div>

                      <div
                        v-for="item in record.InterviewRecordAppraisals"
                        class="evaluation-field"
                        :key="item.Name"
                      >
                        <template
                          v-if="item.Result !== '-' && item.Result !== '未填寫'"
                        >
                          <el-tooltip
                            v-if="item.Remark"
                            class="item"
                            effect="dark"
                            :content="item.Remark"
                            placement="right"
                          >
                            <span>
                              {{ item.Result }}
                            </span>
                          </el-tooltip>
                          <span v-else>{{ item.Result }}</span>
                        </template>
                        <span v-else>{{ item.Result }}</span>
                      </div>

                      <template v-if="interviewList.ResumeType === 'IDL'">
                        <!-- 職等 -->
                        <div class="evaluation-field">
                          {{ record.ExpectedJobLevel }}
                        </div>
                      </template>

                      <!-- 面談備註 -->
                      <div
                        class="evaluation-field"
                        style="height: 150px; overflow-y: auto"
                      >
                        <div>
                          {{ record.Remark }}
                        </div>
                      </div>
                      <!-- 個人備註 -->
                      <div
                        class="evaluation-field"
                        style="height: 150px; overflow-y: auto"
                      >
                        <div>
                          {{ record.PersonalRemark }}
                        </div>
                      </div>
                      <!-- 面談結果 -->
                      <div
                        class="evaluation-field"
                        style="
                          border-bottom: 0.1px solid;
                          border-bottom-color: #dfdfdf;
                        "
                      >
                        <div>
                          {{ record.InterviewResult }}
                        </div>
                      </div>
                    </div>
                  </carousel>
                </div>
              </div>
            </template>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              關閉
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 面談紀錄歷程 Modal -->
    <InterviewProgress ref="interviewProgressRef" :MatchId="MatchId" />

    <!-- 基本履歷 -->
    <div
      id="resumeModal"
      class="modal fade bd-example-modal-lg"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog">
        <div class="modal-content progress-resume-modal">
          <div class="modal-header">履歷</div>
          <perfect-scrollbar class="modal-body">
            <DlResume v-if="showDLResume" :ResumeId="ResumeId" />
            <IdlResume v-if="showIDLResume" :ResumeId="ResumeId" />
          </perfect-scrollbar>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="hideResume">
              關閉
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import carousel from "vue-owl-carousel2";
import { mapGetters, mapActions } from "vuex";
// 履歷
import IdlResume from "@/components/customize/Back/IdlResume";
import DlResume from "@/components/customize/Back/DlResume";
import InterviewProgress from "@/components/back/CandidateData/InterviewProgress";

export default {
  props: ["Name", "UserId", "Email"],

  name: "CandidateProgressModal",

  components: {
    carousel,
    IdlResume,
    DlResume,
    InterviewProgress,
  },
  data() {
    return {
      path: "",

      showModal: false,
      isShow: false,
      jobList: null,

      // 左測
      showRecord: true,
      recordList: [],
      MatchId: null,
      ResumeId: null,
      ResumeType: null,
      // 右側
      jobRecordMatchId: null,
      showProgress: false,
      jobHistoryList: [],

      // 履歷
      showIDLResume: false,
      showDLResume: false,

      // 信件
      mailContent: {},

      // 面談紀錄
      interviewList: {},
    };
  },

  computed: {
    ...mapGetters(["candidateProcessId"]),
  },

  watch: {
    candidateProcessId(candidateId) {
      if (candidateId) {
        this.getApplicationRecord();
        this.showModal = true;
      } else {
        this.showModal = false;
      }
    },

    // 選擇應徵職缺
    jobRecordMatchId: function (value) {
      if (value) {
        this.updateLoading(true);
        this.$api.recruitment
          .getJobHistoryByUserOfBack(value)
          .then((response) => {
            if (response.status === 200) {
              this.jobHistoryList = response.data.JobHistoryList;
              this.ResumeType = response.data.ResumeType;
              this.MatchId = response.data.MatchId;
              this.ResumeId = response.data.ResumeId;
              this.showProgress = true;
            }
            this.updateLoading(false);
          });
      }
    },
  },

  methods: {
    // 取得 應徵職缺列表
    getApplicationRecord() {
      this.$api.recruitment.getJobByUserOfBack(this.Email).then((response) => {
        if (response.status === 200) {
          this.recordList = response.data;
          if (this.recordList.length > 0) {
            this.showRecord = true;
            this.clickRecord(this.recordList[0].MatchId);
          } else {
            this.showRecord = false;
            this.jobRecordMatchId = null;
          }
        }
      });
    },

    // 點擊檢視歷程
    clickRecord(matchId) {
      this.jobRecordMatchId = matchId;
    },

    closeModal() {
      this.$store.commit("OpenCandidateProcessModal", false);
    },

    // 檢視履歷
    viewResume() {
      switch (this.ResumeType) {
        case "IDL":
          this.showIDLResume = true;
          $("#resumeModal").modal("show");
          break;
        case "DL":
          this.showDLResume = true;
          $("#resumeModal").modal("show");
          break;
      }
    },

    hideResume() {
      this.showIDLResume = false;
      this.showDLResume = false;
      $("#resumeModal").modal("hide");
    },

    // 面談邀約信件
    openInterviewMail(interviewId) {
      this.$api.recruitment
        .getNoticeOfInterviewMail(interviewId)
        .then((response) => {
          if (response.status === 200) {
            this.mailContent = response.data;
            $("#mailModal").modal("show");
          }
        });
    },

    // 檢視面談紀錄歷程
    openInterviewProgress(MatchId) {
      this.$refs.interviewProgressRef.getInterviewRecordHistory();
      console.log(MatchId);
    },

    // 檢視面談紀錄
    viewInterview(InterviewId) {
      this.$api.approveInterview
        .getInterviewRecordByInterviewId(InterviewId)
        .then((response) => {
          if (response.status === 200) {
            this.interviewList = response.data;
            $("#historyModal").modal("show");
          }
        });
    },

    // 錄取通知信件
    openHiredMail() {
      const vm = this;
      const api = `${window.endpoints.api}/Notice/GetHireNoticeMail/${vm.MatchId}`;

      vm.$http
        .get(api)
        .then((response) => {
          if (response.status === 200) {
            vm.mailContent = response.data;
            $("#mailModal").modal("show");
          }
        })
        .catch((error) => {
          vm.$notify({
            title: "取得信件失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 報到通知信件
    openReportedMail() {
      const vm = this;
      const api = `${window.endpoints.api}/Notice/GetReportNoticeMail/${vm.MatchId}`;

      vm.$http
        .get(api)
        .then((response) => {
          if (response.status === 200) {
            vm.mailContent = response.data;
            $("#mailModal").modal("show");
          }
        })
        .catch((error) => {
          vm.$notify({
            title: "取得信件失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 感謝函信件
    openThanksMail() {
      const vm = this;
      const api = `${window.endpoints.api}/Notice/GetThanksNoticeMail/${vm.MatchId}`;

      vm.$http
        .get(api)
        .then((response) => {
          if (response.status === 200) {
            vm.mailContent = response.data;
            $("#mailModal").modal("show");
          }
        })
        .catch((error) => {
          vm.$notify({
            title: "取得信件失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  destroyed() {
    this.showModal = false;
    this.$store.commit("OpenCandidateProcessModal", false);
  },
};
</script>

<style lang="scss" scoped>
.progress-resume-modal {
  width: 700px;
}
.progress-job-list-box {
  display: flex;
  .progress-job-list,
  .timeline {
    height: 100%;
  }

  .progress-job-list {
    margin-right: 20px;
    height: 100vh;
    overflow-y: auto;
    padding: 10px 0 0 20px;
    width: 25%;
    .job-item {
      background-color: rgba(255, 255, 255, 0.15);
      margin-bottom: 10px;
      padding: 10px 15px;
      color: #fff;
      display: flex;
      align-items: center;
      cursor: pointer;
      border-radius: 5px;
      border: 1px solid rgba(255, 255, 255, 0.35);
      .time {
        margin-right: 15px;
        text-align: center;
        span {
          display: block;
          font-family: Arial, Helvetica, sans-serif;
          font-weight: lighter;
          opacity: 0.6;
          &:nth-child(1) {
            font-size: 1.3em;
            margin-bottom: -9px;
          }
          &:nth-child(2) {
            font-size: 1.2em;
          }
        }
        .status {
          background-color: #abc7ec;
          color: #3b425d;
          font-size: 0.9em;
          font-weight: bolder;
          border-radius: 3px;
        }
      }
      .info {
        flex: 1;
        .job-name {
          font-size: 1.2em;
          margin-bottom: 10px;
        }
        .d-name,
        .d-nunber {
          font-size: 0.9em;
        }
      }
      .day {
        margin-left: 20px;
        i {
          display: block;
          opacity: 0.6;
        }
        .counter {
          font-size: 1.2em;
          display: inline-block;
        }
        span {
          font-size: 0.6em;
        }
      }

      &.active {
        background-color: #5380f7;
      }
    }
  }

  .notice {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    letter-spacing: 2px;
    outline: 0;
    font: 24px Open Sans, sans-serif;
    color: #fff;
    cursor: default;
    text-align: center;
    img {
      width: 350px;
      opacity: 0.9;
    }
    p {
      margin: 0;
    }
  }

  .timeline {
    padding-left: 180px;
    flex: 1;
    height: 100vh;
    overflow-y: auto;
    margin-top: 10px;

    ul {
      border-left: 2px solid #fff;
      display: inline-block;
      list-style: none;
      padding-left: 40px;
      padding-top: 60px;
      min-height: 100vh;
      li {
        padding-left: 40px;
        color: #fff;
        text-align: left;
        margin-bottom: 60px;
        position: relative;

        .icon-wrap {
          position: absolute;
          left: -64px;
          top: 20px;
          background-color: #3b425d;
          width: 50px;
          height: 50px;
          text-align: center;
          line-height: 50px;
          border-radius: 50%;
          border: 1px solid #fff;
          z-index: 3;
        }

        .time-wrap {
          font-weight: bolder;
          font-family: Arial, Helvetica, sans-serif;
          display: inline-block;
          border-bottom: 1px solid #fff;
          margin-left: -60px;
          padding-left: 60px;
          padding-right: 40px;
          position: relative;
          margin-bottom: 10px;
          font-size: 2em;
          opacity: 0.5;
          letter-spacing: 2px;
          width: 270px;

          &:after {
            content: "";
            width: 10px;
            height: 10px;
            border-radius: 50%;
            border: 1px solid #fff;
            display: inline-block;
            position: absolute;
            right: -5px;
            bottom: -5px;
            background-color: #fff;
          }
        }
        .text-wrap {
          font-size: 1.4em;
          font-weight: bold;
        }
        .note-wrap {
          opacity: 0.5;
        }

        .button-wrap {
          margin-top: 15px;
          .btn {
            background: #abc7ec;
            padding: 5px 15px;
            border-radius: 25px;
          }
        }

        &.welcome {
          div {
            font-size: 2em;
            font-weight: bolder;
          }
        }
      }
    }
  }

  @media screen and (max-width: 900px) {
    .timeline ul li div {
      width: 250px;
    }
    .timeline ul li:nth-child(even) div {
      left: -289px;
      /*250+45-6*/
    }
  }

  @media screen and (max-width: 600px) {
    .timeline ul li {
      margin-left: 20px;
    }
    .timeline ul li div {
      width: calc(100vw - 91px);
    }
    .timeline ul li:nth-child(even) div {
      left: 45px;
    }
    .timeline ul li:nth-child(even) div::before {
      left: -15px;
      border-width: 8px 16px 8px 0;
      border-color: transparent #abc7ec transparent transparent;
    }
  }

  /* EXTRA/CLIP PATH STYLES
–––––––––––––––––––––––––––––––––––––––––––––––––– */
  .timeline-clippy ul li::after {
    width: 40px;
    height: 40px;
    border-radius: 0;
  }

  .timeline-rhombus ul li::after {
    clip-path: polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);
  }

  .timeline-rhombus ul li div::before {
    bottom: 12px;
  }

  .timeline-star ul li::after {
    clip-path: polygon(
      50% 0%,
      61% 35%,
      98% 35%,
      68% 57%,
      79% 91%,
      50% 70%,
      21% 91%,
      32% 57%,
      2% 35%,
      39% 35%
    );
  }

  .timeline-heptagon ul li::after {
    clip-path: polygon(
      50% 0%,
      90% 20%,
      100% 60%,
      75% 100%,
      25% 100%,
      0% 60%,
      10% 20%
    );
  }

  .timeline-infinite ul li::after {
    animation: scaleAnimation 2s infinite;
  }

  @keyframes scaleAnimation {
    0% {
      transform: translateX(-50%) scale(1);
    }
    50% {
      transform: translateX(-50%) scale(1.25);
    }
    100% {
      transform: translateX(-50%) scale(1);
    }
  }

  /* FOOTER STYLES
–––––––––––––––––––––––––––––––––––––––––––––––––– */
  .page-footer {
    position: fixed;
    right: 0;
    bottom: 20px;
    display: flex;
    align-items: center;
    padding: 5px;
    color: black;
    background: rgba(255, 255, 255, 0.65);
  }

  .page-footer a {
    display: flex;
    margin-left: 4px;
  }
}

#mailModal {
  .modal-content {
    background-image: url(~@/assets/img/card_bg.png);
    background-position: top;
    background-size: cover;
    &:after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background-color: rgba(83, 128, 247, 0.85);
      background-color: rgba(59, 61, 64, 0.85);
      z-index: 1;
    }
    & > button {
      z-index: 2;
    }
    .modal-body {
      z-index: 2;

      .title {
        color: #fff;
        text-align: left;
        position: relative;
        font-family: Arial, Helvetica, sans-serif;
        font-weight: bolder;
        padding-left: 15px;

        &::after {
          content: "";
          position: absolute;
          background-color: #5380f7;
          width: 300px;
          height: 15px;
          left: 0;
          bottom: 7px;
        }

        h2,
        h4 {
          display: inline-block;
          position: relative;
          z-index: 2;
          text-shadow: 2px 2px 5px rgba(136, 107, 107, 0.2);
          letter-spacing: 1px;
        }

        h2 {
          margin-right: 10px;
        }
      }
      .form-content {
        background-color: #fff;
        padding: 20px;
        border-radius: 5px;
      }
    }
  }

  .form-content {
    input[type="text"],
    input[type="number"],
    select {
      width: 100%;
      border: none;
      background: #f5f5f5;
      margin: 15px 0 10px 0;
      padding: 6px 5px 6px 10px;
      letter-spacing: 1px;
      border-radius: 3px;
    }
    input[type="text"]::placeholder,
    input[type="number"]::placeholder {
      font-family: "微軟正黑體", sans-serif;
      letter-spacing: 1px;
    }
    input[type="text"]:focus,
    input[type="number"]:focus {
      outline: 0;
    }

    .submit-btn {
      margin-top: 30px;
      border-radius: 3px;
      color: #eee;
      letter-spacing: 2px;
      padding: 6px 30px;
      background-color: #5380f7;
    }

    /deep/ .date-select-style {
      .mx-input-wrapper {
        width: 100%;
        border: none;
        background: #f5f5f5;
        margin: 15px 0 10px 0;
        padding: 6px 5px 6px 10px;
        .mx-input {
          border: none;
          padding: 0;
          box-shadow: none;
          height: 24px;
          letter-spacing: 1px;
        }
        .mx-input::placeholder {
          font-family: "微軟正黑體", sans-serif;
          font-size: 16px;
          letter-spacing: 1px;
        }
      }
    }
  }
}
</style>
